import React from 'react'
import { Uploader, withNotifier } from 'stylist'
import { Consumer as UploadsConsumer } from 'components/UploadsContext'

const VideoUploader = ({ notify, hide, children }) => (
  <UploadsConsumer>
    {({ startUpload }) => (
      <Uploader
        accept="video/mp4"
        name="file"
        onChange={file =>
          startUpload(file).then(() =>
            notify(
              'success',
              'Your video has successfully uploaded, check back soon to view its highlights.',
              { sticky: true }
            )
          )
        }
      />
    )}
  </UploadsConsumer>
)

export default withNotifier(VideoUploader)



// WEBPACK FOOTER //
// ./src/routes/videos/components/VideoUploaderV3.js